import { render, staticRenderFns } from "./orderListPC.vue?vue&type=template&id=4913de98&scoped=true"
import script from "./orderListPC.vue?vue&type=script&lang=js"
export * from "./orderListPC.vue?vue&type=script&lang=js"
import style0 from "./orderListPC.vue?vue&type=style&index=0&id=4913de98&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4913de98",
  null
  
)

export default component.exports